import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Drawer, AppBar, Toolbar, Tooltip, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import DrawerHeader from '../../../atoms/drawerHeader';
import AreaProperties from "./AreaProperties";
import { setImageMapData } from "../../../../store/global/actions";
import { getImageMapData } from "../../../../store/global/selectors";
import AlertDialog from '../../../atoms/alertDialog/AlertDialog';

const drawerWidth = 500;
const useStyles = makeStyles((theme) => ({
    areaDrawer: {
        overflow: 'auto',
        width: drawerWidth,
        backgroundColor: '#fff',
        marginTop: '8rem',
        height: 'calc(100vh - 128px)', // 128 = topbar (64) + bottom drawer topbar (64) 
        boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
        zIndex: 1000
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: '0.625rem',
        marginRight: '0.625rem',
    },
    areaPropertiesContainer: {
        minHeight: 'calc(100vh - 256px)',  // 256 = topbar (64) + bottom drawer topbar (64) + asset explorer topbar (64) + breadcrumb (64)
        padding: 15,
        paddingTop: 5
    },
    deleteAreaButtonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        color: 'red',
        // borderBottom: '1px solid rgba(0,0,0,1)'

    }

}));

export default function AreaPropertiesDrawer(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [isDrawerOpen, setDrawerOpening] = useState(false);
    const [isDialogOpen, setDialogOpen] = useState(false);

    const {selectedAreaName, areas} = useSelector(getImageMapData);

    const onClose = () => {
        dispatch(setImageMapData({ selectedAreaName: null, shapeToEdit: null }));
    }

    const handleOnProceed = () => {
        let filteredAreas = areas.filter((currentArea) => selectedAreaName !== currentArea.name);
        dispatch(setImageMapData({ areas: filteredAreas }))
        onClose();
        setDialogOpen(false);
    }

    useEffect(() => {
        if(areas && selectedAreaName){
            const filteredArea = areas.filter(area => area.name === selectedAreaName);
            if(filteredArea?.length === 1){
                setDrawerOpening(true)
            }else{
                setDrawerOpening(false)
            }
        }else{
            setDrawerOpening(false);
        }
    },[areas, selectedAreaName])

    return (
        <Drawer
            className={classes.areaListDrawer}
            anchor="right"
            open={isDrawerOpen}
            classes={{
                paper: classes.areaDrawer,
            }}
            disablePortal
            style={{top: '128px'}}
            hideBackdrop
            id={"areaPropertiesDrawer"}
        >
            <AlertDialog
                open={isDialogOpen ? true : false}
                title='Delete'
                content={`Are you sure to delete ${selectedAreaName}?`}
                proceedText='Delete'
                proceedColor='secondary'
                abortColor='primary'
                onClose={() => setDialogOpen(false)}
                onProceed={handleOnProceed}
            />
            <AppBar position="static">

                <Toolbar>
                    <Grid container>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={8} align={'center'} direction={'column'} justify={'center'}>
                            <h5 style={{ marginTop: 10 }}><DrawerHeader name={selectedAreaName} /> </h5>
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                            <Tooltip title="Close">
                                <IconButton onClick={onClose}><CancelIcon /></IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>


            <Grid item xs={12} className={classes.areaPropertiesContainer}>
                <Grid xs={12} item className={classes.deleteAreaButtonWrapper}>
                    <Tooltip title='Delete Area'>
                        <IconButton style={{color: 'red'}} onClick={() => setDialogOpen(true)}><DeleteIcon /></IconButton>
                    </Tooltip>
                </Grid>
                <AreaProperties onClose={onClose} />
            </Grid>
        </Drawer>
    );
}


